import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { useAppStore } from '../store';
import type { CalendarEvent } from '../types/calendar';

export function useCalendarEvents() {
  const date = useAppStore((s) => s.selectedDate);

  return useQuery<CalendarEvent[]>({
    queryKey: ['calendar-events', date],
    queryFn: () => api.calendarEvents.list(date),
    refetchInterval: 3 * 60 * 1000,
    staleTime: 60 * 1000,
  });
}
